import _classCallCheck from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _assertThisInitialized from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/assertThisInitialized";
import React from 'react';
import Utils from '../utils/utils';
import Mixins from '../utils/mixins';
import __reactComponentDispatchEvent from '../runtime-helpers/react-component-dispatch-event.js';
import __reactComponentSlots from '../runtime-helpers/react-component-slots.js';
import __reactComponentSetProps from '../runtime-helpers/react-component-set-props.js';

var F7Chip =
/*#__PURE__*/
function (_React$Component) {
  _inherits(F7Chip, _React$Component);

  function F7Chip(props, context) {
    var _this;

    _classCallCheck(this, F7Chip);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(F7Chip).call(this, props, context));
    _this.__reactRefs = {};

    (function () {
      Utils.bindMethods(_assertThisInitialized(_assertThisInitialized(_this)), ['onClick', 'onDeleteClick']);
    })();

    return _this;
  }

  _createClass(F7Chip, [{
    key: "onClick",
    value: function onClick(event) {
      this.dispatchEvent('click', event);
    }
  }, {
    key: "onDeleteClick",
    value: function onDeleteClick(event) {
      this.dispatchEvent('delete', event);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var self = this;
      var props = self.props;
      var media = props.media,
          text = props.text,
          deleteable = props.deleteable,
          className = props.className,
          id = props.id,
          style = props.style,
          mediaTextColor = props.mediaTextColor,
          mediaBgColor = props.mediaBgColor,
          outline = props.outline;
      var mediaEl;
      var labelEl;
      var deleteEl;

      if (media || self.slots && self.slots.media) {
        var mediaClasses = Utils.classNames('chip-media', mediaTextColor && "text-color-".concat(mediaTextColor), mediaBgColor && "bg-color-".concat(mediaBgColor));
        mediaEl = React.createElement('div', {
          className: mediaClasses
        }, media || this.slots['media']);
      }

      if (text || self.slots && self.slots.text) {
        labelEl = React.createElement('div', {
          className: 'chip-label'
        }, text, this.slots['text']);
      }

      if (deleteable) {
        deleteEl = React.createElement('a', {
          ref: function ref(__reactNode) {
            _this2.__reactRefs['deleteEl'] = __reactNode;
          },
          className: 'chip-delete'
        });
      }

      var classes = Utils.classNames(className, 'chip', {
        'chip-outline': outline
      }, Mixins.colorClasses(props));
      return React.createElement('div', {
        ref: function ref(__reactNode) {
          _this2.__reactRefs['el'] = __reactNode;
        },
        id: id,
        style: style,
        className: classes
      }, mediaEl, labelEl, deleteEl);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.refs.el.removeEventListener('click', this.onClick);

      if (this.refs.deleteEl) {
        this.refs.deleteEl.removeEventListener('click', this.onDeleteClick);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.refs.el.addEventListener('click', this.onClick);

      if (this.refs.deleteEl) {
        this.refs.deleteEl.addEventListener('click', this.onDeleteClick);
      }
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(events) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return __reactComponentDispatchEvent.apply(void 0, [this, events].concat(args));
    }
  }, {
    key: "slots",
    get: function get() {
      return __reactComponentSlots(this.props);
    }
  }, {
    key: "refs",
    get: function get() {
      return this.__reactRefs;
    },
    set: function set(refs) {}
  }]);

  return F7Chip;
}(React.Component);

__reactComponentSetProps(F7Chip, Object.assign({
  id: [String, Number],
  className: String,
  style: Object,
  media: String,
  text: [String, Number],
  deleteable: Boolean,
  mediaBgColor: String,
  mediaTextColor: String,
  outline: Boolean
}, Mixins.colorProps));

F7Chip.displayName = 'f7-chip';
export default F7Chip;